import { checkFormLock } from '../../utilities/formsUtilities';

export const AllInLocationsBase = (superclass) => class extends superclass {
    async _fetchLocations(){
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-locations&nonce=${this.nonce}`;
        try{
            let response = await fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })
            let data = await response.json();
            let locations = data.locations;
            for(let i=0;i<locations.length;i++){
                let isLocked = await checkFormLock(`location__${locations[i].id}__${this.currentOrg}`,this.currentUser.id,this.restUrl,this.nonce);
                locations[i].isLocked = isLocked;
            }
            locations = locations.sort((a,b)=>a.name.localeCompare(b.name));
            this.organisation.locations = locations;
            this._setLocationsToSessionStorage();
            this.eventManager.emit(`allin-organisation-${this.name}-update`,{organisation:JSON.stringify(this.organisation)});
        }
        catch(error){
            console.error('Error:', error);
        };
    } 

    async _fetchProvisions(){
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-provisions-all&nonce=${this.nonce}`;
        try{
            const response = await fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })
            const data = await response.json();
            this.provisions = data.provisions;
            this._loading = false;
            this._setProvisionsToSessionStorage();
            this.eventManager.emit(`allin-organisation-${this.name}-update`,{provisions:JSON.stringify(this.provisions)});
        }
        catch(error){
            console.error('Error:', error);
        }
    }

    async _fetchInvoices(){
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-invoices&nonce=${this.nonce}`;
        try{
            let response = await fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })
            let data = await response.json();
            this._invoices = data.invoices;
            this.organisation.invoices = this._invoices;
            this.eventManager.emit(`allin-organisation-${this.name}-update`,{organisation:JSON.stringify(this.organisation)});
        }
        catch(error){
            console.error('Error:', error);
        };   
    }

    _getLocationById(id){
        let lId = this.organisation?.locations?.find((loc)=>loc.id==id);
        if(lId&&!lId.publishedStatus){
            lId.publishedStatus = "Published";
        }
        return lId;
    }

    
    
}